export const PROGRESS_BAR_TEST_ID = 'progress-bar-test';

export const PROGRESS_BAR_EMPTY = 0;